import { ReactNode } from "react";

import TableCellGroup from "ds/components/Table/Row/CellGroup";

import { ModulePullRequestsTableRow } from "../../gql";
import useModulePullRequestsTableExpandedRowsStore from "../useExpandedRowsStore";

type ModulePullRequestsTablePullRequestGroupToggleProps = {
  pullRequest: ModulePullRequestsTableRow;
  children: ReactNode;
};

const ModulePullRequestsTablePullRequestGroupToggle = ({
  pullRequest,
  children,
}: ModulePullRequestsTablePullRequestGroupToggleProps) => {
  const isExpanded = useModulePullRequestsTableExpandedRowsStore((state) =>
    state.expandedRows.has(pullRequest.id)
  );
  const toggleRow = useModulePullRequestsTableExpandedRowsStore((state) => state.toggleRow);

  return (
    <TableCellGroup
      isActive
      isGroupOpen={isExpanded}
      onPress={() => toggleRow(pullRequest.id)}
      title={`Toggle ${pullRequest.title} test cases`}
    >
      {children}
    </TableCellGroup>
  );
};

export default ModulePullRequestsTablePullRequestGroupToggle;
